<template>
  <div class="desktron-common">
    <h2 class="common-title">为什么选择Desktron云桌面</h2>
    <div class="common-subtitle">核心技术领先</div>
    <div class="common-desc dt-desc">打造极致高清流畅体验</div>
    <ul class="dt-list">
      <li v-for="(item, index) in copywriting1" :key="index" class="dt-item">
        <img class="dt-item-img" :src="item.icon" />
        <div>
          <h3 class="dt-item-title">{{ item.title }}</h3>
          <p class="dt-item-subTitle">{{ item.desc }}</p>
        </div>
      </li>
    </ul>
    <div class="dt-rtc"></div>

    <div class="common-subtitle" id="solutions">高效灵活</div>
    <div class="common-desc dt-desc">部署、运维、使用，原来可以如此便捷</div>
    <ul class="dt-list dt-list1">
      <li v-for="(item, index) in copywriting2" :key="index" class="dt-item">
        <img class="dt-item-img" :src="item.icon" />
        <div>
          <h3 class="dt-item-title">{{ item.title }}</h3>
          <p class="dt-item-subTitle">{{ item.desc }}</p>
        </div>
      </li>
    </ul>
    <div class="dt-detail"></div>

    <div class="common-subtitle">安全可靠</div>
    <div class="common-desc dt-desc">
      多重权限策略叠加，全方位保障企业信息安全
    </div>
    <ul class="dt-list dt-list2">
      <li v-for="(item, index) in copywriting4" :key="index" class="dt-li">
        {{ item }}
      </li>
    </ul>

    <van-tabs
      color="#0C89E4"
      title-active-color="#0C89E4"
      title-inactive-color="#1D2129"
      swipe-threshold="4"
      swipeable
    >
      <van-tab v-for="item in tabs" :title="item.title" :key="item.key">
        <div class="dt-van">{{ item.desc }}</div>
      </van-tab>
    </van-tabs>

    <div class="dt-triangle"></div>

    <ul class="dt-func">
      <li
        class="dt-func-item"
        v-for="(item, index) in copywriting3"
        :key="index"
      >
        <img class="dt-func-img" :src="item.icon" />
        <h3 class="dt-func-title">{{ item.title }}</h3>
        <p class="dt-func-desc">{{ item.desc }}</p>
      </li>
    </ul>

    <div class="Scenes" id="application">
      <div class="Scenes-after"></div>
      <h2 class="common-title common-title1">Desktron云桌面应用场景</h2>

      <van-tabs
        color="#0C89E4"
        title-active-color="#0C89E4"
        title-inactive-color="#1D2129"
        swipe-threshold="4"
        v-model="active"
        background="transparent"
        swipeable
      >
        <van-tab v-for="item in content" :key="item.key">
          <template #title>
            <div class="Scenes-item">
              <img
                class="Scenes-item-img"
                :src="item.key === active ? item.active : item.icon"
              />
              {{ item.tabTitle }}
            </div>
          </template>
          <img :src="item.pic" class="Scenes-right" />
          <div class="Scenes-left">
            <h3 class="Scenes-title">{{ item.title }}</h3>
            <ul class="Scenes-list1">
              <li
                v-for="(item, index) in item.list1"
                :key="index"
                class="Scenes-item1"
              >
                {{ item }}
              </li>
            </ul>
            <h3 class="Scenes-title">优势</h3>
            <ul class="Scenes-list2">
              <li
                v-for="(item, index) in item.list2"
                :key="index"
                class="Scenes-item2"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </van-tab>
      </van-tabs>
      <a class="btn-common btn-primary dt-btn" @click="handleClick">申请试用</a>
    </div>

    <!-- <h2 class="common-title">
      此外，更有Desktron高密度桌 <br />面集群方案“高性能、低成本”
    </h2>

    <div class="dt-case"></div>

    <ul class="dt-list dt-list2">
      <li v-for="(item, index) in copywriting5" :key="index" class="dt-li">
        {{ item }}
      </li>
    </ul>

    <ul class="dt-square">
      <li
        class="square-item"
        v-for="(item, index) in copywriting6"
        :key="index"
        :class="'square-item' + index"
      >
        <img class="square-img" :src="item.icon" />
        <div>
          <div class="square-title">{{ item.title }}</div>
          <div class="square-desc">{{ item.desc }}</div>
        </div>
      </li>
    </ul>

    <a class="btn-common btn-primary dt-btn" @click="handleClick">申请试用</a> -->

    <div class="dt-industryApply" id="design" v-if="!isReplace">
      <h2 class="industryApply-title">满足高精行业需求，全面提升企业效率</h2>
      <p class="industryApply-subTitle">Desktron云桌面行业应用</p>
      <ul class="industryApply-list">
        <li class="list-item" v-for="(item, index) in list" :key="index">
          <img
            class="list-item-img"
            :src="require(`@/assets/desktron/IndustryApply/${item.icon}`)"
          />

          <div class="list-item-title">
            {{ item.title }}
          </div>
        </li>
      </ul>
      <a class="btn-common btn-primary industryApply-btn" @click="handleClick"
        >申请试用</a
      >
    </div>

    <div class="pdn dt-proof" v-if="!isReplace">
      <h2 class="title">超过30w+企业的共同信赖</h2>
      <div class="cont">
        <div class="item" v-for="(item, index) in usr_list" :key="index">
          <img :src="require(`@/assets/users/${item}`)" alt="" />
        </div>
      </div>
    </div>
    <Certificate v-if="!isReplace" />

    <div class="dt-bottom">
      <div class="bottom-title">Desktron云桌面</div>
      <div class="bottom-subTitle">为您提供系统化解决方案</div>
      <div class="bottom-desc">
        混合桌面模式（虚拟桌面+物理桌面），帮您快速构建安全、高性能、低成本的企业桌面办公体系
      </div>
      <a class="btn-common btn-primary bottom-btn" @click="handleClick"
        >申请试用</a
      >
    </div>
  </div>
</template>
<script>
import Certificate from "@/components/Common/Certificate";
import { Tabs, Tab } from "vant";
import icon1 from "@/assets/desktron/icon1.png";
import icon2 from "@/assets/desktron/icon2.png";
import icon3 from "@/assets/desktron/icon3.png";
import icon4 from "@/assets/desktron/icon4.png";
import icon5 from "@/assets/desktron/icon5.png";
import icon6 from "@/assets/desktron/icon6.png";

import func1 from "@/assets/desktron/func1.png";
import func2 from "@/assets/desktron/func2.png";
import func3 from "@/assets/desktron/func3.png";
import func4 from "@/assets/desktron/func4.png";
import func5 from "@/assets/desktron/func5.png";
import func6 from "@/assets/desktron/func6.png";
import func7 from "@/assets/desktron/func7.png";
import func8 from "@/assets/desktron/func8.png";

import case1 from "@/assets/desktron/case1.png";
import case2 from "@/assets/desktron/case2.png";
import case3 from "@/assets/desktron/case3.png";
import case4 from "@/assets/desktron/case4.png";

import pic1 from "@/assets/desktron/Scenes/pic1.png";
import pic2 from "@/assets/desktron/Scenes/pic2.png";
import pic3 from "@/assets/desktron/Scenes/pic3.png";
import pic4 from "@/assets/desktron/Scenes/pic4.png";
import pic5 from "@/assets/desktron/Scenes/pic5.png";

import icon11 from "@/assets/desktron/Scenes/icon1.png";
import icon22 from "@/assets/desktron/Scenes/icon2.png";
import icon33 from "@/assets/desktron/Scenes/icon3.png";
import icon44 from "@/assets/desktron/Scenes/icon4.png";
import icon55 from "@/assets/desktron/Scenes/icon5.png";
import icon1Active from "@/assets/desktron/Scenes/icon1-active.png";
import icon2Active from "@/assets/desktron/Scenes/icon2-active.png";
import icon3Active from "@/assets/desktron/Scenes/icon3-active.png";
import icon4Active from "@/assets/desktron/Scenes/icon4-active.png";
import icon5Active from "@/assets/desktron/Scenes/icon5-active.png";
export default {
  components: {
    Certificate,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
  },
  props: {
    path: {
      type: String,
      default: "",
    },
    isReplace: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      list: Object.freeze([
        {
          title: "勘察设计",
          icon: "pic1.png",
        },
        {
          title: "汽车设计/制造",
          icon: "pic2.png",
        },
        {
          title: "芯片设计/制造",
          icon: "pic3.png",
        },
        {
          title: "教育培训",
          icon: "pic4.png",
        },
        {
          title: "游戏开发",
          icon: "pic5.png",
        },
        {
          title: "影视动画",
          icon: "pic6.png",
        },
        {
          title: "工业设计/仿真",
          icon: "pic7.png",
        },
        {
          title: "平面设计",
          icon: "pic8.png",
        },
      ]),

      copywriting1: Object.freeze([
        {
          title: "RTC框架",
          desc: "自研实时音视频RTC框架+智能视频编解码算法，从底层结构优化提升传输性能",
          icon: icon1,
        },
        {
          title: "画质无损，色彩精准",
          desc: "最高支持4K@60hz超清画质；支持智能无损模式，办公场景亦能身临其境；同时提供4:4:4真色彩模式供专业级场景使用",
          icon: icon2,
        },
        {
          title: "高清流畅",
          desc: "端到端延时低至40ms，键鼠操作流畅丝滑",
          icon: icon3,
        },
      ]),

      copywriting2: Object.freeze([
        {
          title: "高效运维、弹性扩容",
          desc: "资源随需快速部署，运维管理简单高效；云桌面配置规格丰富，满足不同场景需求",
          icon: icon4,
        },
        {
          title: "丰富外设，深度兼容信创",
          desc: "接入便捷，支持多种外设，支持跨系统、跨终端、跨架构发起访问",
          icon: icon5,
        },
        {
          title: "200+全球节点加速",
          desc: "搭配Zuler OTT SD-WAN外网加速，随时随地流畅办公",
          icon: icon6,
        },
      ]),

      copywriting3: Object.freeze([
        {
          title: "屏幕水印",
          desc: "可设置明/暗两种屏幕水印",
          icon: func1,
        },
        {
          title: "设备-用户绑定",
          desc: "云桌面与登录账号权属绑定",
          icon: func2,
        },
        {
          title: "系统锁定",
          desc: "超时、最小化、连接时都可锁定",
          icon: func3,
        },
        {
          title: "双因认证",
          desc: "多重验证方式确保本人操作",
          icon: func4,
        },
        {
          title: "日志记录",
          desc: "详细记录连接时间，永久保存",
          icon: func5,
        },
        {
          title: "端到端加密",
          desc: "银行级安全传输协议+非对称加密+包过滤技术",
          icon: func6,
        },
        {
          title: "可控剪切板和文件传输",
          desc: "可批量管控剪切板、文件传输方向",
          icon: func7,
        },
        {
          title: "操作录屏",
          desc: "云端同步加密录屏",
          icon: func8,
        },
      ]),

      copywriting4: Object.freeze([
        "所有数据都保存在服务器，在本地客户端上不保存，仅通过加密的远程协议做视频流展示。",
        "23项安全措施，实现事前数据不落地、事中过程可记录、事后行为可溯源。",
      ]),

      copywriting5: Object.freeze([
        "高密度桌面集群（High-Density Desktop Cluster）是一种计算架构，旨在提供高度集中的计算资源给用户。在这种集群中，大量的虚拟桌面会被部署在少量的物理服务器上，从而实现高度的资源共享和利用率。",
        " 高密度桌面集群可以提供桌面虚拟化服务，使用户可以通过网络访问他们的个人虚拟桌面。用户可以在自己的设备上运行桌面应用程序，而实际的计算和数据存储都在集群服务器上进行。这种集中式的计算模型可以提供更高的安全性、可靠性和资源管理效率。",
      ]),
      copywriting6: Object.freeze([
        {
          icon: case1,
          title: "原有设备",
          desc: "集中存放，利旧使用",
        },
        {
          icon: case2,
          title: "新购设备",
          desc: "刀片服务器，节省空间，降低运维工作量",
        },
        {
          icon: case3,
          title: "便携管理",
          desc: "通过IPMI接口，便携监控硬件健康状态",
        },
        {
          icon: case4,
          title: "性能无损耗",
          desc: "支持无需虚拟化模式，呈现最优性能",
        },
      ]),

      usr_list: Object.freeze([
        "walmart@2x.png",
        "bodor@2x.png",
        "bohai@2x.png",
        "naked@2x.png",
        "cir@2x.png",
        "vic2.png",
        "teren@2x.png",
        "yuncong@2x.png",
        "guoda@2x.png",
        "chuanmeidaxue@2x.png",
        "ennead@2x.png",
        "zenlayer@2x.png",
      ]),

      tabs: Object.freeze([
        {
          key: 0,
          title: "数据安全",
          desc: "确保业务数据、代码、模型、算法等核心数字资产不被窃取、不被破坏、不被恶意加密锁死",
        },
        {
          key: 1,
          title: "管理安全",
          desc: "从公司管理层面对远控访问的相关设备和人员进行管控，具备完善的远程访问管理制度和流程规范",
        },
        {
          key: 2,
          title: "过程安全",
          desc: "在远程访问过程中对访问者身份进行验证，并对违规操作、文件转移等人为风险进行管控",
        },
        {
          key: 3,
          title: "架构安全",
          desc: "系统方案等结构牢固、运行逻辑清晰、能够与公司原有安全体系紧密配合，经受住潜在的攻击",
        },
        {
          key: 4,
          title: "网络安全",
          desc: "对企业内网系统和传输过程进行保护，确保传输内容保密防盗，并且能识别、阻断恶意访问",
        },
      ]),

      content: Object.freeze([
        {
          key: 0,
          tabTitle: "高性能场景",
          icon: icon11,
          active: icon1Active,
          title: "设计、制图、视频编辑等图形制作渲染场景",
          list1: [
            "适用于专业图形设计（如CAD/SolidWorks/Revit等）、视频动画制作、图形渲染等场景，广泛应用于工业设计、建筑设计、勘察设计、游戏开发、影视剪辑等涉及高性能场景的行业。 ",
            "在专业设计领域，需要有GPU支持的桌面提供性能保障，在关注操控的流畅性的同时，也关注设计成果的数据安全。",
          ],
          list2: [
            "核心技术领先，在运行3D软件、各类CAX软件时能获得最高4K@60hz，端到端延时低至40ms的高清流畅体验。",
            "弹性、多规格的图形计算实例，可快速部署使用。",
            "支持GPU虚拟化+工作站托管，节约成本。",
          ],
          pic: pic1,
        },
        {
          key: 1,
          tabTitle: "信创访问场景",
          icon: icon22,
          active: icon2Active,
          title: "使用信创设备进行办公的场景",
          list1: [
            "适用于使用信创设备/系统进行办公的场景。 ",
            "传统的云桌面1.0主要关注对于Windows系统的虚拟化，以及基于常见系统和终端发起访问；对于信创系统和芯片的兼容，缺乏改造经验、改造工具，存在多重挑战。",
          ],
          list2: [
            "全面兼容中国芯, 适配飞腾、鲲鹏、兆芯、海光、海思麒麟等国产CPU；",
            "全面支持统信UOS、银河麒麟、中科方德等操作系统；",
            "支持虚拟应用，提供终端应用过渡能力，平滑演进信创云建设。 ",
          ],
          pic: pic2,
        },
        {
          key: 2,
          tabTitle: "外部访问场景",
          icon: icon33,
          active: icon3Active,
          title: "企业多地办公、出差员工远程访问的场景 ",
          list1: [
            "适用于公司多分支机构、分布式办公、出差办公、居家办公等办公场景，例如大型企业在各地的分公司等。",
            "外部访问中，企业首先关注数据安全不落地；与此同时，企业用户希望可以随时随地使用各类设备接入云桌面，轻松实现远程安全办公。",
          ],
          list2: [
            "接入便捷，支持跨系统（Windows、Mac、Linux、Android、iOS）、跨终端（PC、Pad、手机）、跨架构（广泛支持x86&Arm架构，同时深度兼容信创系统及芯片）发起访问；",
            "搭配Zuler OTT SD-WAN外网加速，外网也能随时随地流畅办公；",
            "在手机、平板等移动终端的交互上进行专项优化，触屏亦能流畅操控。",
          ],
          pic: pic3,
        },
        {
          key: 3,
          tabTitle: "临时使用场景",
          icon: icon44,
          active: icon4Active,
          title: "短期使用的场景",
          list1: [
            "适用于公司外包、暑期实习、供应商支持等临时短期使用场景，以及图书馆、云教室、呼叫中心等公用终端场景。",
            "在公用桌面场景中，用户关注桌面办公环境能否迅速搭建和回收。",
          ],
          list2: [
            "云桌面即开即用，支持弹性扩容，资源随需快速创建。",
            "同时配置规格丰富，可满足不同人群的需求。",
            "虚拟桌面+远程物理桌面，一个系统统一管理，运维管理简单高效。",
          ],
          pic: pic4,
        },
        {
          key: 4,
          tabTitle: "数据安全管控场景",
          icon: icon55,
          active: icon5Active,
          title: "数据安全管控场景",
          list1: [
            "适用于企事业核心机构、银行办公、研发中心、软件开发外包管理、供应商上下游办公等各类安全办公场景。",
            "以上安全办公场景中，对数据和设计资料有保密要求，需防止泄漏。",
          ],
          list2: [
            "所有数据都保存在服务器，在本地客户端上不保存，仅通过加密的Desktron音视频传输协议做视频流展示。",
            "23项安全措施，实现事前数据不落地、事中过程可记录、事后行为可溯源。",
          ],
          pic: pic5,
        },
      ]),

      active: 0,
    };
  },
  methods: {
    handleClick() {
      this.$router.push({
        path: this.path,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.common-title {
  font-family: PingFang SC;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  padding: 40px 0 30px;
  line-height: 34px;
  color: #1d2129;
}
.common-title1 {
  padding-bottom: 8px;
}
.common-subtitle {
  color: #0c89e4;
  font-size: 16px;
  font-weight: 500;
  padding-left: 20px;
}

.common-desc {
  font-size: 18px;
  font-weight: 500;
  margin-top: 4px;
  color: #1d2129;
  padding: 0 20px;
}
.btn-common {
  display: block;
  box-sizing: border-box;
  width: 256px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid rgba(105, 116, 167, 0.22);
  background: #fff;
  color: #0c89e4;
  text-align: center;
  line-height: 38px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #ecf6fd;
    border-color: #0c89e4;
  }

  &:active {
    background-color: #ecf6fd;
    border-color: #0c89e4;
  }
}

.btn-common + .btn-common {
  margin-left: 18px;
}

.btn-primary {
  background-color: #0c89e4;
  color: #ffffff;
  border-color: #0c89e4;

  &:hover {
    background-color: #2495e7;
    border-color: #2495e7;
  }

  &:active {
    background-color: #0b7bcd;
    border-color: #0b7bcd;
  }
}
.desktron-common {
  background: #fff;
  overflow-x: hidden;

  ::v-deep .van-tabs--line .van-tabs__wrap {
    position: relative;
    height: 45px;

    &::after {
      position: absolute;
      content: "";
      left: 0;
      right: 0;
      bottom: 0;
      height: 1px;
      background-color: #0000001a;
    }

    .van-tab--active {
      position: relative;

      &::after {
        position: absolute;
        content: "";
        left: 0;
        right: 0;
        bottom: 0;
        height: 2px;
        background-color: #0c89e4;
      }
    }
    .van-tabs__line {
      width: 0;
      height: 0;
    }

    .van-tab {
      width: auto;
      margin-right: 10px;
      padding: 0 6px;
      font-size: 14px;
    }
  }
}
.dt-desc {
  margin-bottom: 18px;
}

.dt-list {
  padding: 0 0 15px;

  .dt-item {
    display: flex;
    margin-bottom: 15px;
    padding: 0 20px;
  }

  .dt-item-img {
    width: 40px;
    height: 40px;
    margin-right: 12px;
  }

  .dt-item-title {
    font-size: 16px;
    font-weight: 500;
    color: #1d2129;
  }

  .dt-item-subTitle {
    font-size: 14px;
    color: #4e5969;
    line-height: 20px;
    margin-top: 4px;
  }

  .dt-li {
    position: relative;
    color: #4e5969;
    font-size: 14px;
    line-height: 1.4;
    margin-bottom: 12px;
    padding-left: 20px;
    margin: 0 20px 10px;

    &:last-child {
      margin-bottom: 0;
    }

    &::before {
      content: "";
      position: absolute;
      top: 6px;
      left: 6px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #4e5969;
    }
  }
}

.dt-rtc {
  height: 242px;
  background: url("~@/assets/desktron/RTC.png") center no-repeat;
  background-size: 100% auto;
  margin: 20px 20px;
}

.dt-detail {
  height: 202px;
  background: url("~@/assets/desktron/detail.png") center no-repeat;
  background-size: 100% auto;
  margin: 0 10px 30px;
}

.dt-triangle {
  height: 231px;
  background: url("~@/assets/desktron/triangle.png") center no-repeat;
  background-size: 100% auto;
  margin: 0 6px 20px;
}

.dt-case {
  height: 245px;
  background: url("~@/assets/desktron/case.png") center no-repeat;
  background-size: 100% auto;
  margin: 0 20px 26px;
}

.dt-proof {
  background: #ffffff;
  .title {
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1e232a;
    margin-bottom: 18px;
    text-align: center;
  }
  .cont {
    text-align: center;
    .item {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 110px;
      height: 50px;
      background: #ffffff;
      box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.08);
      border-radius: 5px;
      margin-left: 3px;
      margin-right: 3px;
      margin-top: 6px;
      img {
        text-align: center;
        height: 25px;
        width: auto;
      }
    }
  }
}

.dt-industryApply {
  background: #272e3b;
  text-align: center;
  padding: 36px 0 40px;

  .industryApply-btn {
    margin: 6px auto 0;
  }
}

.industryApply-title {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #fff;
}

.industryApply-subTitle {
  color: #ffffffb8;
  font-size: 18px;
  margin-top: 12px;
  text-align: center;
}

.industryApply-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 16px;
  margin: 28px 0 0;

  .list-item {
    position: relative;
    width: 164px;
    height: 124px;
    border-radius: 8px;
    margin-bottom: 14px;
    overflow: hidden;
  }

  .list-item-img {
    width: 100%;
    height: 100%;
  }

  .list-item-title {
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 40px;
    background: rgba(0, 0, 0, 0.8);
    overflow: hidden;
    text-align: center;
    line-height: 40px;
    color: #fff;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
  }
}

.dt-func {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 18px 15px 20px;
}

.dt-func-item {
  width: 50%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .dt-func-img {
    width: 66px;
    height: 66px;
  }

  .dt-func-title {
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    margin-top: 8px;
  }

  .dt-func-desc {
    color: #4e5969;
    margin-top: 4px;
    text-align: center;
    font-size: 12px;
  }
}

.dt-square {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin-top: 14px;
  border: 1px solid #e5e8ef;
  margin: 0 20px 30px;
  border-radius: 6px;

  .square-item {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e5e8ef;
    height: 86px;

    &:last-of-type {
      border-bottom: none;
    }
  }

  .square-img {
    width: 48px;
    height: 48px;
    margin-right: 12px;
  }

  .square-title {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    color: #1d2129;
    margin-bottom: 3px;
  }

  .square-desc {
    color: #4e5969;
    font-size: 14px;
    line-height: 1.4;
  }
}

.dt-btn {
  position: relative;
  margin: 0 auto;
}

.dt-van {
  padding: 20px 20px;
  font-size: 14px;
  color: #4e5969;
  line-height: 1.5;
}

.Scenes-right {
  height: 264px;
  margin: 24px 0;
}

.Scenes-title {
  color: #000;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.4;
  margin: 0 20px;
}

.Scenes-list1 {
  margin: 14px 20px 24px;
}

.Scenes-list2 {
  margin: 12px 20px 30px;
}

.Scenes-item1 {
  position: relative;
  padding-left: 24px;
  font-size: 14px;
  color: #4e5969;
  line-height: 1.4;
  margin-bottom: 14px;

  &:last-child {
    margin-bottom: 0;
  }

  &::before {
    content: "";
    position: absolute;
    top: 7px;
    left: 0;
    width: 8px;
    height: 8px;
    background-color: #0c89e4;
    border-radius: 50%;
  }
}

.Scenes-item2 {
  position: relative;
  padding-left: 24px;
  font-size: 14px;
  color: #4e5969;
  line-height: 1.4;
  margin-bottom: 14px;

  &:last-child {
    margin-bottom: 0;
  }

  &::before {
    content: "";
    position: absolute;
    top: 1px;
    left: 0;
    width: 16px;
    height: 16px;
    background: url("~@/assets/desktron/Scenes/right.png") center no-repeat;
    background-size: 100% auto;
  }
}

.Scenes-item {
  display: flex;
  align-items: center;
}

.Scenes-item-img {
  width: 24px;
  height: 24px;
  margin-right: 6px;
}

.Scenes {
  position: relative;
  background: #f7faff;
  padding-bottom: 40px;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 179px;
    height: 220px;
    background: url("~@/assets/desktron/Scenes/half1.png") center no-repeat;
    background-size: 100% 100%;
  }

  .Scenes-after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 288px;
    background: url("~@/assets/desktron/Scenes/half2.png") center no-repeat;
    background-size: 100% 100%;
  }
}

.dt-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 35px 20px 38px;
  line-height: 1.5;
  text-align: center;
  background: url("~@/assets/desktron/bottom.png") center no-repeat;
  background-size: 100% 100%;

  .bottom-title,
  .bottom-subTitle {
    color: #1d2129;
    font-size: 20px;
    font-weight: 600;
  }

  .bottom-subTitle {
    color: #0c89e4;
  }

  .bottom-desc {
    color: #86909c;
    font-size: 14px;
    margin-top: 10px;
  }

  .bottom-btn {
    margin-top: 24px;
  }
}
</style>
